// extracted by mini-css-extract-plugin
export default {"input":"InputText_input__ZHaSm","light":"InputText_light__Jesrs","modal":"InputText_modal__C+6ue"};